export default __webpack_public_path__ + "static/media/no.c2a3c34c.svg";